import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import Column from './Column';
import { action, computed } from 'mobx';
import { isNullOrUndefined } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import { isGUID } from '../utils/isGUID';
import { DataStore } from '../stores';
import { inject } from '../utils';
import { ColumnConfig } from '../models/configuration/explorer/ColumnConfig';

interface GroupedColumnProps {
    theme?: any;
    dataStore?: DataStore;
    column: ColumnConfig;
    columnIndex: number;
    groupedColumnType: string;
}

@inject('dataStore')
@observer
class GroupedColumn extends Component<GroupedColumnProps> {
    constructor(props) {
        super(props);

        if (this.props.column.groups) {
            this.setInitialGroupIndex();
        }
    }

    @computed
    get columnStore() {
        return this.props.dataStore.columnStore;
    }

    @action
    setInitialGroupIndex = () => {
        const { column, columnIndex } = this.props;
        let selectedGroupIndex;
        if (this.columnStore.hasColumnGroupsSet) {
            const columnGroups = this.columnStore.columnGroups;
            const configColumnKey = column.key;
            const columnGroupSelectedValue = !isGUID(configColumnKey)
                ? columnGroups[configColumnKey]
                : columnGroups[columnIndex];

            if (isNaN(Number(columnGroupSelectedValue))) {
                selectedGroupIndex = column.groups.findIndex(
                    group => group.key === columnGroupSelectedValue
                );
            } else {
                selectedGroupIndex = Number(columnGroupSelectedValue);
            }
        }

        if (
            isNullOrUndefined(selectedGroupIndex) ||
            selectedGroupIndex === -1
        ) {
            const selectedConfigGroupIndex = column.groups.findIndex(
                c => c.selected
            );

            selectedGroupIndex = this.selectedGroupIndex
                ? this.selectedGroupIndex
                : selectedConfigGroupIndex > -1
                ? selectedConfigGroupIndex
                : 0;
        }

        this.columnStore.selectedGroupMap.set(
            this.props.columnIndex,
            selectedGroupIndex
        );
    };

    @computed
    get selectedGroupIndex() {
        let index = this.columnStore.selectedGroupMap.get(
            this.props.columnIndex
        );
        if (this.props.column.groups) {
            if (index >= this.props.column.groups.length) {
                const selectedConfigGroupIndex = this.props.column.groups.findIndex(
                    c => c.selected
                );
                // tslint:disable-next-line: prefer-conditional-expression
                if (selectedConfigGroupIndex > -1) {
                    index = selectedConfigGroupIndex;
                } else {
                    index = 0;
                }
            }
        }
        return index;
    }

    @computed
    get column() {
        return this.props.column.groups
            ? this.props.column.groups[this.selectedGroupIndex]
            : this.props.column;
    }

    @computed
    get groupedHeader() {
        const { theme } = this.props;
        const { column, selectedGroupIndex } = this;
        return (
            <Column
                column={column}
                selectedGroupIndex={selectedGroupIndex}
                scope="colGroup"
                borderStyle="none"
                padding="16px 8px 0"
                theme={{
                    ...theme,
                    ColumnLabel: {
                        margin: '0 0 0.5em 0',
                        padding: '0 0 0.5em 0',
                        ...theme.ColumnGroupLabel,
                    },
                }}
                colSpan={column.columns.length}
            />
        );
    }

    @computed
    get groupedSubHeader() {
        const { column, props } = this;
        const { theme } = props;
        const { columns } = column;

        if (columns && columns.length > 0) {
            return columns.map((subColumn, subIndex) => (
                <Column
                    key={subIndex}
                    column={subColumn}
                    fontSize="xs"
                    fontFamily="body"
                    fontWeight="regular"
                    padding="0 0 16px 0"
                    scope="col"
                    {...theme.SubColumnHeader}
                    theme={{
                        ...theme,
                        ColumnLabel: {
                            ...theme.ColumnGroupLabel,
                        },
                    }}
                />
            ));
        }
    }

    render() {
        const { groupedColumnType } = this.props;
        if (groupedColumnType === 'GroupedHeader') {
            return this.groupedHeader || null;
        }
        if (groupedColumnType === 'GroupedSubHeader') {
            return this.groupedSubHeader || null;
        }
        return null;
    }
}

export default withTheme(GroupedColumn) as any;



// WEBPACK FOOTER //
// ./src/Components/GroupedColumn.tsx